import { detect } from 'detect-browser'
const browser = detect()
const {
  base_urls,
  stripe_key
} = _server_config_ // eslint-disable-line

export default {
  base_urls: {
    ...base_urls, // eslint-disable-line
    FIXER_API_BASE_URL: 'http://api.fixer.io/',
    PIXABAY_API_BASE_URL: 'https://pixabay.com/api/',
    YOUTUBE_API_BASE_URL: 'https://www.googleapis.com/youtube/v3/'
  },
  youtube_authorization_key: 'AIzaSyDr3WLCNH6sR4VsaDWKxV_BNA1hoTfKuVY',
  stripe_key,
  pixabay_key: '5641725-e75e511c837fcd9e6b06449eb',
  supportedLanguages: ['en', 'de'],
  draggableDefaultOptions: {
    animation: 600,
    handle: '.sort-handle',
    scroll: true,
    forceFallback: (browser && browser.name === 'chrome')
  },
  notificationDefaultOptions: {
    customClass: 'custom_notify',
    duration: 5000
  },
  moduleMapping: [
    {
      moduleId: -100,
      moduleName: 'imprint-view'
    }, {
      moduleId: -101,
      moduleName: 'mainmenu-view'
    }, {
      moduleId: 0,
      moduleName: 'submenu-view'
    }, {
      moduleId: 1,
      moduleName: 'news-view'
    }, {
      moduleId: 2,
      moduleName: 'event-view'
    }, {
      moduleId: 3,
      moduleName: 'contact-detail-view'
    }, {
      moduleId: 4,
      moduleName: 'about-us-view'
    }, {
      moduleId: 5,
      moduleName: 'contact-form-view'
    }, {
      moduleId: 6,
      moduleName: 'map-view'
    }, {
      moduleId: 7,
      moduleName: 'team-view'
    }, {
      moduleId: 8,
      moduleName: 'opening-hors-view'
    }, {
      moduleId: 9,
      moduleName: 'milestones-view'
    }, {
      moduleId: 10,
      moduleName: 'facebook-view'
    }, {
      moduleId: 11,
      moduleName: 'twitter-view'
    }, {
      moduleId: 12,
      moduleName: 'text-content-view'
    }, {
      moduleId: 13,
      moduleName: 'image-content-view'
    }, {
      moduleId: 14,
      moduleName: 'click2call-view'
    }, {
      moduleId: 15,
      moduleName: 'click2email-view'
    }, {
      moduleId: 16,
      moduleName: 'youtube-view'
    }, {
      moduleId: 17,
      moduleName: 'website-view'
    }, {
      moduleId: 18,
      moduleName: 'rssfeed-view'
    }, {
      moduleId: 19,
      moduleName: 'image-gallery-view'
    }, {
      moduleId: 20,
      moduleName: 'poi-view'
    }, {
      moduleId: 22,
      moduleName: 'appointment-view'
    }, {
      moduleId: 23,
      moduleName: 'coupons-view'
    },
    {
      moduleId: 24,
      moduleName: 'pdf-view'
    }, {
      moduleId: 26,
      moduleName: 'rating-feedback-view'
    }, {
      moduleId: 27,
      moduleName: 'appointment-view'
    }, {
      moduleId: 28,
      moduleName: 'appointment-view'
    }, {
      moduleId: 29,
      moduleName: 'appointment-view'
    }, {
      moduleId: 31,
      moduleName: 'loyality-view'
    }, {
      moduleId: 34,
      moduleName: 'radio-view'
    }, {
      moduleId: 38,
      moduleName: 'login-view'
    }, {
      moduleId: 39,
      moduleName: 'chat-view'
    }, {
      moduleId: 49,
      moduleName: 'custom-form-view'
    }, {
      moduleId: 50,
      moduleName: 'instagram-view'
    }, {
      moduleId: 51,
      moduleName: 'custom-code-view'
    }, {
      moduleId: 101,
      moduleName: 'news-detail-view'
    }, {
      moduleId: 102,
      moduleName: 'loyality-pin-view'
    }, {
      moduleId: 103,
      moduleName: 'loyality-qr-view'
    }, {
      moduleId: 104,
      moduleName: 'coupon-pin-view'
    }, {
      moduleId: 105,
      moduleName: 'coupon-qr-view'
    }, {
      moduleId: 106,
      moduleName: 'youtube-detail-view'
    }, {
      moduleId: 107,
      moduleName: 'youtube-play-view'
    }, {
      moduleId: 108,
      moduleName: 'rss-detail-view'
    }, {
      moduleId: 109,
      moduleName: 'rss-website-view'
    }, {
      moduleId: 110,
      moduleName: 'facebook-post-view'
    }, {
      moduleId: 111,
      moduleName: 'image-gallery-scroll-view'
    }, {
      moduleId: 112,
      moduleName: 'image-gallery-zoom-pinch-view'
    }, {
      moduleId: 201,
      moduleName: 'event-detail-view'
    }, {
      moduleId: 202,
      moduleName: 'event-website-view'
    },
    {
      moduleId: -1001,
      moduleName: 'bootup-sync'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/config.js